/**
 * BUT-842: legacy redirect for `/lessons/my`, moved here to its own file so
 * `lessons.routes.tsx` stays component-free (react-refresh/only-export-components).
 * Preserves search + hash so tenant-handle/club-id survive the bounce to `/plans`.
 */

import { Navigate, useLocation } from 'react-router';

export function MyLessonsRedirect() {
  const { search, hash } = useLocation();
  return <Navigate to={{ pathname: '/plans', search, hash }} replace />;
}
